// ADX / DMI on the chart (DWLF-340). The pane and its events use the jobs' ADX(14) with the
// library's default levels, computed over the FULL series and clipped to the visible window, so a
// short window (mobile) keeps the 2 x length warm-up. ADX is context (trending vs ranging), not a
// trigger: the trend level (25) and fade level (20) are drawn as guides.
import { ADX as LibraryADX } from '@andywilliams/indicators';

export const ADX_PARAMS = Object.freeze({ length: 14 });
const { trendLevel, fadeLevel } = LibraryADX.resolveAdxParams(ADX_PARAMS);
export const ADX_GUIDE_LEVELS = Object.freeze({ trendLevel, fadeLevel });

// Indigo: no other event family uses it, so ADX markers stay distinct on the shared strip.
export const ADX_COLORS = Object.freeze({ adx: '#5C6BC0', plusDI: '#66BB6A', minusDI: '#EF5350' });

const inWindow = (t, { from, to }) => (from === undefined || t >= from) && (to === undefined || t <= to);

const clip = (points, window) => (points || [])
  .filter((point) => point && Number.isFinite(point.t) && Number.isFinite(point.v) && inWindow(point.t, window))
  .map((point) => ({ t: point.t, v: point.v }));

/** { adx, plusDI, minusDI } as [{ t, v }] within the window, or null when there is no ADX to draw. */
export const adxSeries = (ADX, { fullCandles, from, to }) => {
  const result = ADX.computeADX(fullCandles, ADX_PARAMS);
  const adx = clip(result.adx, { from, to });
  if (!adx.length) {return null;}
  return { adx, plusDI: clip(result.plusDI, { from, to }), minusDI: clip(result.minusDI, { from, to }) };
};

/** The jobs' adx.* events (same detector and length) within the window. */
export const adxEvents = (ADX, { fullCandles, from, to }) => (
  ADX.detectEvents(fullCandles, ADX_PARAMS).filter((event) => inWindow(event.t, { from, to }))
);

export const adxPaneTitle = () => `ADX / DMI (${ADX_PARAMS.length})`;
